module.exports = __webpack_public_path__ + "static/media/Impreza-GE-GH-Sti.4b41895a.webp";